import Layout from '../modules/Layout';
import RedeemCoupon from '../modules/RedeemCoupon';
import { CustomNextPage } from '../lib/types';
import { redeemCouponPageQuery } from '../core-types';
import { getQueryString } from '../lib/utils';
import { bootstrap } from '../lib/bootstrap';
import { useQuery, gql } from '@apollo/client';

const REDEEM_COUPON_PAGE_QUERY = gql`
  query redeemCouponPageQuery {
    redeemCouponPage: sanityRedeemCouponPage {
      title
      heading
    }
  }
`;

const RedeemCouponPage: CustomNextPage<{
  statusCode?: number;
}> = props => {
  const { url, statusCode } = props;
  const step = getQueryString(url.query.step);
  const { data, loading } = useQuery<redeemCouponPageQuery>(
    REDEEM_COUPON_PAGE_QUERY
  );
  const title = data && data.redeemCouponPage && data.redeemCouponPage.title;
  return (
    <Layout
      statusCode={statusCode}
      title={title}
      url={url}
      loading={loading}
      hideChrome={!!step}
      centerContent
      contentProps={{
        mx: 0,
        mb: 0,
        py: 0
      }}
      render={() => {
        if (!data || !data.redeemCouponPage) {
          return null;
        }
        return <RedeemCoupon data={data} step={step} />;
      }}
    />
  );
};

RedeemCouponPage.getInitialProps = async ctx => {
  const redeemCouponPageQueryResult = await ctx.apolloClient.query<
    redeemCouponPageQuery
  >({
    query: REDEEM_COUPON_PAGE_QUERY
  });
  let statusCode;
  if (!redeemCouponPageQueryResult.data?.redeemCouponPage) {
    statusCode = 404;
    if (ctx.res) {
      // eslint-disable-next-line require-atomic-updates
      ctx.res.statusCode = statusCode;
    }
  }

  return {
    statusCode
  };
};

export default bootstrap(RedeemCouponPage);
